import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPieChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.2018 10.6023L14.6311 10.8169C15.2489 11.1259 15.5064 11.8849 15.1036 12.4461C13.6669 14.448 11.3193 15.7521 8.66715 15.7521C4.29463 15.7521 0.75 12.2075 0.75 7.83495C0.75 4.83477 2.41879 2.22435 4.87878 0.881303C5.48472 0.550484 6.206 0.89902 6.43686 1.54964L6.5977 2.00294L8.49868 7.36023C8.60676 7.66482 8.82862 7.91571 9.11769 8.06025L14.2018 10.6023ZM6.5977 2.00294C7.24476 1.77333 7.94135 1.64835 8.66713 1.64835C12.0839 1.64835 14.8538 4.41819 14.8538 7.83497C14.8538 8.82972 14.619 9.76963 14.2018 10.6023",
		stroke: "#18181B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgPieChart);
export default ForwardRef;
